// @flow
import * as React from 'react';
import createCancelable from 'app/common/lib/makeCancelablePromise';

type InjectedProps = {
  makeCancelablePromise: (promise: Promise<any>, uniqueKey?: string) => Promise<any>,
};

export default function withPromiseCancellation<Props: InjectedProps>(
  Subject: React.ComponentType<Props>,
): React.ComponentType<$Diff<Props, InjectedProps>> {
  return class SubjectWithPromiseCancelableHandler extends React.Component<
    $Diff<Props, InjectedProps>,
  > {
    // $FlowFixMe: new errors found from flow 0.96 upgrade
    static displayName = `WithPromiseCancellation(${Subject.displayName || Subject.name})`;
    componentWillUnmount() {
      [
        ...Object.keys(this.cancelCallbackMap).map((key) => this.cancelCallbackMap[key]),
        ...this.cancelCallbacks,
      ].forEach((cb) => cb());
      this.cancelCallbacks = [];
      this.cancelCallbackMap = {};
    }

    makeCancelablePromise = (promise: Promise<any>, uniqueKey?: string) => {
      if (uniqueKey) {
        const cancelPrevious = this.cancelCallbackMap[uniqueKey];
        if (cancelPrevious) {
          cancelPrevious();
          delete this.cancelCallbackMap[uniqueKey];
        }
      }

      const { cancel, promise: wrappedPromise } = createCancelable(promise);

      if (uniqueKey) {
        this.cancelCallbackMap[uniqueKey] = cancel;
      } else {
        this.cancelCallbacks.push(cancel);
      }
      return wrappedPromise;
    };

    cancelCallbacks: Array<() => void> = [];
    cancelCallbackMap: { [string]: () => void } = {};

    render() {
      return <Subject {...this.props} makeCancelablePromise={this.makeCancelablePromise} />;
    }
  };
}
